import {
  FUNCTION_ACTION_TICKET,
  STOCK_TRANSFER_REJECT_REASON,
  TICKET_STATUS,
} from '@/utils/enum';
import { TICKET_STATUS_NAME } from '@/utils/enum-name';

export const TICKET_STATUS_OPTIONS = [
  { id: TICKET_STATUS.NEW, label: 'Mới' },
  {
    id: TICKET_STATUS.RECORDED_INFOMATION,
    label: 'Ghi nhận thông tin',
  },
  { id: TICKET_STATUS.PROCESSING, label: 'Đang xử lí' },
  { id: TICKET_STATUS.COMPLETED, label: 'Hoàn thành' },
  { id: TICKET_STATUS.REJECT, label: 'Từ chối' },
];

export const STOCK_TRANSFER_REJECT_REASON_OPTIONS = [
  {
    id: STOCK_TRANSFER_REJECT_REASON.INSUFFICIENT_STOCK,
    label: 'Không đủ hàng để hỗ trợ',
  },
  { id: STOCK_TRANSFER_REJECT_REASON.DEVICE_FAULT, label: 'Máy lỗi' },
  {
    id: STOCK_TRANSFER_REJECT_REASON.HAS_ORDER_ID,
    label: 'Đã có đơn hàng ID',
  },
  {
    id: STOCK_TRANSFER_REJECT_REASON.CUSTOMER_VIEWING,
    label: 'Khách đang xem',
  },
  { id: STOCK_TRANSFER_REJECT_REASON.OTHER, label: 'Khác' },
];

export function createTicketStatusUpdate(ticket = {}) {
  return {
    id: ticket.id ?? null,
    status: ticket.status ?? -1,
    reason: ticket.reason ?? '',
    functionAction: ticket.TicketTypeSetting
      ? ticket.TicketTypeSetting.functionAction
      : null,
    rejectReasonType: ticket.rejectReasonType || null,
    orderId: ticket.orderId || null,
    stockSlipId: ticket.stockSlipId || null,
  };
}

export function isStockTransferStatusUpdate(ticketUpdate) {
  return (
    ticketUpdate.functionAction === FUNCTION_ACTION_TICKET.STOCK_TRANSFER
  );
}

export function buildTicketStatusUpdatePayload(ticketUpdate) {
  const payload = {
    status: ticketUpdate.status,
    id: ticketUpdate.id,
  };

  if (
    payload.status === null ||
    payload.status === undefined ||
    payload.status === -1
  ) {
    return { error: 'Vui lòng chọn trạng thái' };
  }

  if (!TICKET_STATUS_NAME[payload.status]) {
    return { error: 'Trạng thái không hợp lệ' };
  }

  if (isStockTransferStatusUpdate(ticketUpdate)) {
    if (payload.status === TICKET_STATUS.COMPLETED) {
      if (!ticketUpdate.stockSlipId) {
        return { error: 'Vui lòng nhập mã phiếu chuyển kho' };
      }
      payload.stockSlipId = ticketUpdate.stockSlipId;
    }

    if (payload.status === TICKET_STATUS.REJECT) {
      if (!ticketUpdate.rejectReasonType) {
        return { error: 'Vui lòng chọn lí do từ chối' };
      }

      payload.rejectReasonType = ticketUpdate.rejectReasonType;

      if (
        ticketUpdate.rejectReasonType ===
        STOCK_TRANSFER_REJECT_REASON.HAS_ORDER_ID
      ) {
        if (!ticketUpdate.orderId) {
          return { error: 'Vui lòng nhập mã đơn hàng ID' };
        }
        payload.orderId = ticketUpdate.orderId;
      }

      if (
        ticketUpdate.rejectReasonType === STOCK_TRANSFER_REJECT_REASON.OTHER
      ) {
        if (!ticketUpdate.reason) {
          return { error: 'Vui lòng nhập lí do từ chối' };
        }
        payload.reason = ticketUpdate.reason;
      }
    }
  } else if (payload.status === TICKET_STATUS.REJECT) {
    if (!ticketUpdate.reason) {
      return { error: 'Vui lòng nhập lí do từ chối' };
    }
    payload.reason = ticketUpdate.reason;
  }

  return { payload };
}
